import { useCallback, useEffect, useState } from "react";
import { api } from "../../../lib/api";
import { useAuth } from "../../../providers/AuthProvider";

export type Dealer = {
  id: string;
  business_id: string;
  name: string;
  contact_person: string | null;
  phone: string | null;
  email: string | null;
  gst_number: string | null;
  address: string | null;
  lat?: string | null;
  lng?: string | null;
  place_id?: string | null;
  status: string | null;
};

export function useDealers() {
  const { token } = useAuth();
  const [rows, setRows] = useState<Dealer[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    if (!token) {
      setRows([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await api.dealers.list({ token });
      setRows(res.data);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Failed to load dealers");
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { dealers: rows, loading, error, reload };
}

